









































import { defineComponent, ref } from "@vue/composition-api";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import DataTable from "@/components/data/data-table.vue";
import { Team } from "@/swagger/models";
import { DataTableConfig } from "@/components/data/data-table";
import { useRouter } from "@/router/router";
import { teamService } from "@/services/team";

export default defineComponent({
    name: "teams-table",
    props: {
        customerId: {
            type: Number,
            required: true,
        },
    },
    components: { Page, PageHeader, DataTable },
    setup(props, context) {
        const { router } = useRouter(context);

        const teams = ref<Team[]>([]);
        const loading = ref(false);

        (async () => {
            loading.value = true;
            teams.value = await teamService.find({ params: { customer: props.customerId } });
            loading.value = false;
        })();

        const tableConfig: DataTableConfig<Team> = {
            clickItemCallback: (item) => {
                router.push({
                    name: "team",
                    params: {
                        teamId: item.id.toString(),
                    },
                });
            },
            items: teams,
            fields: [
                {
                    label: "ID",
                    field: "id",
                    compact: true,
                },
                {
                    label: "Name",
                    field: "name",
                },
                {
                    label: "Created",
                    field: "createdAt",
                    compact: true,
                },
                {
                    label: "Updated",
                    field: "updatedAt",
                    compact: true,
                },
            ],
        };

        return { tableConfig, loading };
    },
});
